module.exports = __webpack_public_path__ + "img/boxio_ad_scaled.62b68371.jpg";